import { motion } from 'framer-motion'
import styled from 'styled-components'

export const MotionDocumentSectionFieldsContainer = styled(motion.div)`
  margin-bottom: 1rem;
`

export const documentFieldVariants = {
  initial: { opacity: 0, x: -32 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -32 },
}

export const documentFieldTransition = {
  duration: 0.3,
  ease: 'easeOut' as const,
}
